<template>
	<b-modal id="modal-editbucket" title="Update bucket">
		<span class="close" @click="onClose">
			<x-icon size="1.25x" class="custom-class"></x-icon>
		</span>
		<div class="">
			<b-form>
				<label class="sr-only" for="inline-form-input-name"
					><span>Bucket name</span>
					<!-- <div class="c-tooltip" v-b-tooltip.hover title="">
            <span>
              ?
            </span>
          </div> -->
				</label>
				<b-input
					id="inline-form-input-name"
					class=""
					placeholder="Research #1"
					v-model="bucket.title"
				></b-input>

				<!-- <label for="inline-form-input-username">Description</label>
        <b-form-textarea
          v-model="bucket.description"
          id="inline-form-input-username"
          placeholder="Something about this bucket"
        ></b-form-textarea> -->

				<label> Underline color </label>
				<b-form-group class="radio-color">
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="2"
						class="c2"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="3"
						class="c3"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="4"
						class="c4"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="5"
						class="c5"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="6"
						class="c6"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
					<b-form-radio
						v-model="bucket.color"
						name="some-radios"
						:value="7"
						class="c7"
						><check-icon size="1.25x"></check-icon
					></b-form-radio>
				</b-form-group>
				<b-button @click="updateBucket" variant="primary"
					>Update bucket</b-button
				>
			</b-form>
			<hr />
			<b-button @click="removeBucket"> Remove bucket </b-button>
		</div>
	</b-modal>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
export default {
	components: {
		XIcon,
		CheckIcon,
	},
	data: function () {
		var obj = {
			lock: false,
			bucket: {},
		};
		return obj;
	},
	computed: {},
	methods: {
		onClose: function () {
			this.$bvModal.hide('modal-editbucket');
		},
		setBucket: function (bucket) {
			bucket = JSON.parse(JSON.stringify(bucket));
			this.bucket = bucket;
		},
		updateBucket: function () {
			this.lock = true;
			this.$store.dispatch('bucket/updateBucket', this.bucket).then((data) => {
				this.$bvModal.hide('modal-editbucket');
				this.reset();
			});
		},
		reset: function () {
			this.lock = false;
			this.bucket = {};
		},
		removeBucket: function () {
			this.$bvModal.hide('modal-editbucket');
			this.$store.dispatch('bucket/removeBucket', this.bucket._id);
		},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-editbucket___BV_modal_outer_ {
	.radio-color {
		.custom-control {
			display: inline-block;
			min-height: auto;
			padding: 0;
			width: 40px;
			height: 40px;
			margin-right: 10px;

			.custom-control-label {
				width: 100%;
				height: 100%;
				cursor: pointer;
				svg {
					position: absolute;
					top: 8px;
					left: 8px;
					width: calc(100% - 16px);
					height: calc(100% - 16px);
					z-index: 1;
					opacity: 0;
					color: rgba(0, 0, 0, 0.7);
					transition: opacity 100ms linear;
				}
				&:before {
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					pointer-events: none;
					content: '';
					background-color: #fff;
					border: #adb5bd solid 4px;
					background-image: none !important;
					border-radius: 50%;
				}
				&:after {
					content: none;
				}
			}

			@each $name, $arr in $bucket_themes {
				&.#{$name} {
					.custom-control-label {
						&:before {
							border-color: nth($arr, 2);
							background-color: nth($arr, 1);
						}
					}
				}
			}
			.custom-control-input:focus ~ .custom-control-label:before {
				box-shadow: 0 0 0 3px $primary;
			}
			.custom-control-input:checked ~ .custom-control-label svg {
				opacity: 1;
			}
		}
	}

	.modal-footer {
		display: none;
	}
	.modal-dialog {
		max-width: 420px;
	}
}
</style>
